import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";
import { adminArchivedToggleCommon } from "./exam-admin-common";
import { examAdminExamsDetail } from "./exam-admin-exams-detail";

export const examAdminExams = {
  ...adminArchivedToggleCommon,
  pageTitle: "考试中心",
  pageSubtitle: "管理正式考试的创建、分配、发布、状态流转和成绩发布。",
  createSuccess: "考试创建成功",
  archiveSuccess: "考试已归档",
  createAndStartSuccess: "考试创建成功并已立即开始",
  createStartNowFailed: "考试已创建，但立即开始失败：{reason}",
  examRules: "考试规则：",
  assignedCandidates: "已分配考生：",
  stats: {
    totalExamsLabel: "考试总数",
    totalExams: "考试总数：{count}",
    summaryUnavailable: "考试状态统计加载失败，图例计数暂不可用",
    archivedExamsLabel: "归档数量",
    archivedExams: "归档数量：{count}",
    totalCandidatesLabel: "总考试人次",
    totalCandidates: "总考试人次：{count}",
    totalDurationMinutesLabel: "总考试时长",
    totalDurationMinutes: "总考试时长：{count} 分钟",
  },
  table: {
    code: "考试编号",
    name: "考试名称",
    searchPlaceholder: "按考试编号或名称搜索",
    codeSearchPlaceholder: "按编码搜索",
    paperVersionSearchPlaceholder: "按试卷名称/编码搜索",
    status: commonShortNouns.status,
    paperVersion: "试卷版本",
    paperVersionMissing: "试卷版本缺失（ID #{id}）",
    duration: "时长",
    candidates: "考生数",
    environmentLimits: "容器限制",
    environmentLimitActive: "并发 {count}",
    environmentLimitTotal: "总计 {count}",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
  },
  batch: {
    publish: "批量发布",
    start: "批量开始",
    end: "批量结束",
    archive: "批量归档",
    publishScores: "批量发布成绩",
    selectFirst: "请先选择考试",
    actionSuccess: "批量执行 {action} 完成，共 {count} 场",
    actionPartial: "批量执行 {action} 完成 {success} 场，失败 {failed} 场",
    publishScoresSuccess: "批量发布成绩完成，共 {count} 场",
    publishScoresPartial: "批量发布成绩完成 {success} 场，失败 {failed} 场",
    confirm: {
      batchpublishScoresTitle: "确认批量发布成绩？",
      batchpublishScoresDescription: "将对选中的考试批量发布成绩，请确认操作。",
      batcharchiveTitle: "确认批量归档？",
      batcharchiveDescription: "将对选中的考试批量归档，请确认操作。",
      batchendTitle: "确认批量结束？",
      batchendDescription: "将对选中的考试批量结束，请确认操作。",
      batchstartTitle: "确认批量开始？",
      batchstartDescription: "将对选中的考试批量开始，请确认操作。",
      batchpublishTitle: "确认批量发布？",
      batchpublishDescription: "将对选中的考试批量发布，请确认操作。",
    },
  },
  newExamDrawerTitle: "新建考试",
  codeRulePrefix: "考试编号由系统在首次保存成功后自动生成，格式为",
  codeRulePattern: "E-年周-序号",
  codeRuleSuffix: "，生成后不可修改。",
  createWizard: {
    previous: "上一步",
    next: "下一步",
    submit: "创建考试",
    durationRequired: "请输入考试时长",
    startNowDurationRequired: "创建后立即开始必须设置考试时长",
    startMode: "开始方式",
    startModeScheduled: "定时开始",
    startModeImmediate: "创建后立即开始",
    startModeImmediateHint: "创建后系统会自动执行“立即开始”，无需手动再次点击。",
    endTimeAutoHint: "结束时间将自动计算为：{value}",
    endTimeAutoHintEmpty: "请先填写开始时间和考试时长，系统将自动计算结束时间。",
    openExamHint: "当前为开放考试，任何考生都可参与，本步无需指定考生。",
    recommendDuration: "按试卷推荐时长",
    recommendDurationUnavailable: "当前试卷未配置建议时长",
    recommendDurationApplied: "已应用推荐时长：{minutes} 分钟",
    openPaperPicker: "弹窗选择试卷",
    paperPickerTitle: "选择试卷版本",
    paperPickerSearchPlaceholder: "按试卷编号或名称搜索",
    openCandidatePicker: "查找带回考生",
    candidatePickerTitle: "选择考生",
    candidatePickerSearchPlaceholder: "按姓名或用户名搜索",
    recommendName: "AI 推荐名称",
    recommendedNameTemplate: "{title} · 正式考试 · {date}",
    recommendedNameApplied: "已应用推荐考试名称",
    typePolicies: "题型策略",
    paperOptionLabel: "{code} · {title} · V{versionNo}（{versionCode}）",
    typePolicyShuffleQuestions: "题型内题目乱序",
    typePolicyShuffleOptions: "选项 ABCD 打乱",
    typePolicyAllowSelfCheck: "允许考生自主运行",
    typePolicyMaxSelfCheckCount: "最多运行次数",
    typePolicyMaxSelfCheckCountPlaceholder: "不填表示不限",
    typePolicyAllowSelfCheckWithCount: "允许考生自主运行（{count} 次）",
    typePolicyGroupOrder: "顺序策略",
    typePolicyGroupPractical: "实操策略",
    typePolicyGroupAttackDefense: "夺旗策略",
    typePolicyMaxCreateCount: "最多创建环境次数",
    typePolicyMaxCreateCountPlaceholder: "不填表示不限",
    typePolicyMaxCreateCountWithCount: "最多创建环境（{count} 次）",
    typePolicyFlagResultMode: "Flag 判分时机",
    typePolicyFlagResultModeImmediate: "即时判分并显示结果",
    typePolicyFlagResultModeDeferred: "交卷后统一判分",
    typePolicySummary: "已启用：{summary}",
    typePolicySummaryNone: "无",
    customFieldsSectionTitle: "自定义字段",
    selectPaperAction: "选择",
    steps: {
      basic: "试卷与基本信息",
      rules: "考试规则",
      candidates: "考生范围",
    },
  },
  status: "考试状态",
  name: "考试名称",
  nameRequired: "请输入考试名称",
  namePlaceholder: "输入考试名称",
  entryCode: "入口编码",
  entryCodeRequired: "请输入入口编码",
  entryCodePlaceholder: "例如：E-2613-003 或 exam-security-001",
  entrySubdomain: "入口二级域名前缀",
  entrySubdomainPlaceholder: "例如：e-2613-003（访问 e-2613-003.<root-domain>）",
  paperVersion: "试卷版本",
  paperVersionRequired: "请选择试卷版本",
  paperVersionPlaceholder: "选择试卷版本",
  startTime: "开始时间",
  endTime: "结束时间",
  durationMinutes: "考试时长（分钟）",
  publishScoreMode: "成绩发布方式",
  allowLateEntry: "允许迟到进入",
  lateEntryGraceMinutes: "最大迟到时长（分钟）",
  lateEntryGraceMinutesPlaceholder: "不填表示不限",
  earliestSubmitAt: "最早交卷时间",
  earliestSubmitAtPlaceholder: "未到该时间前不允许交卷",
  allowReentry: "允许中断重进",
  allowMultipleSubmit: "允许多次提交",
  maxAttemptCount: "最多作答次数",
  maxAttemptCountRequired: "请输入最多作答次数",
  maxAttemptCountPlaceholder: "不填表示不限",
  accessMode: "参与范围",
  accessModeAssigned: "指定考生参与",
  accessModeOpen: "开放考试（任意考生）",
  resultVisibility: "成绩可见性",
  answerVisibility: "答案可见性",
  assignCandidates: "分配考生",
  assignCandidatesPlaceholder: "选择本场考试的考生",
  advancedConfig: "扩展配置",
  advancedConfigHelp: "常用扩展配置通过表单维护，系统自动生成",
  advancedConfigRetainUnknown: "未识别键会在编辑时保留。",
  examNotice: "考试说明",
  examNoticePlaceholder: "考前须知、环境说明、答题提醒等",
  submitNotice: "交卷提示",
  submitNoticePlaceholder: "交卷确认时给考生的提示语",
  scoreNotice: "成绩发布说明",
  scoreNoticePlaceholder: "例如：成绩将在人工复核后统一发布",
  proctoringNote: "监考备注",
  proctoringNotePlaceholder: "例如：本场考试要求全程开摄像头（V2 预留）",
  environmentNote: "环境备注",
  environmentNotePlaceholder: "例如：编程题和实操题执行环境说明",
  candidateEnvironmentMaxActive: "每考生并发容器上限",
  candidateEnvironmentMaxActivePlaceholder: "不填表示不限制",
  candidateEnvironmentMaxTotal: "每考生容器创建次数上限",
  candidateEnvironmentMaxTotalPlaceholder: "不填表示不限制",
  enableAiReview: "启用 AI 初评",
  autoRecycleEnvironment: "环境自动回收",
  showQuestionNavigation: "显示题号导航",
  configJsonPreview: "config_json 预览",
  detail: examAdminExamsDetail,
};
